<template>
  <a
    :href="url"
    data-size="large"
    target="_blank"
    class="no-underline mx-2"
    >
    <span class="icon icon-document"></span>
  </a>
</template>

<script>
export default {
  props: {
    url: {
      type: String
    }
  },
  data () {
    return {
    }
  }
}
</script>
